export const ADD_STRUCTURE = "/fund/add_structure/";
export const EDIT_STRUCTURE = "/fund/edit_structure/";
